<div [class]="popupStyle">
  <button
    type="button"
    [id]="id"
    [attr.data-toggle]="toggle"
    [attr.aria-haspopup]="true"
    [attr.aria-expanded]="toggle"
    (click)="toggle = !toggle"
    [class]="btnStyleDefault"
    title="{{ label }}">
    <span [class]="btnLabelDefault" [style.max-width.px]="btnFixSize">{{
      label
    }}</span>
  </button>
  <div
    id="dropMenuDefault"
    class="pl-2 ie-custom-dropdown-width"
    [class]="dropMenuDefault"
    [ngClass]="{ 'dropdown-hide': toggle === false, 'dropdown-show': toggle }">
    <div
      id="selectAllDiv"
      class="dropdown-item d-flex"
      title="{{ selectAllText }}">
      <input
        class="form-check-input"
        type="checkbox"
        id="selectAllCheck"
        [(ngModel)]="selectAll"
        (change)="toggleSelectAll()" />
      <label
        id="selectAllCheckLabel"
        class="form-check-label ml-2"
        for="selectAllCheck"
        >{{ selectAllText }}</label
      >
    </div>
    <div
      id="itemDiv"
      class="dropdown-item d-flex"
      *ngFor="let item of objList"
      title="{{ item.name }}">
      <input
        class="form-check-input"
        type="checkbox"
        id="item{{ item.id }}"
        [(ngModel)]="item.isSelected"
        [disabled]="isPermanentlyCheckedItem(item.id)"
        (change)="checkSelectedItem()" />
      <label
        id="itemLabel"
        class="form-check-label ml-2"
        for="item{{ item.id }}"
        >{{ item.name }}</label
      >
    </div>
  </div>
</div>
